module.exports = __webpack_public_path__ + "media/images/top/free-search-af45dd44b5aff70eba4f899eff4eeaf0.svg";